export const en = {
  navbar: {
    links: {
      home: "Home",
      aboutUs: "About Us",
      services: "Services",
      ourPartners: "Our Partners",
      ourTeam: "Our Team",
      contactUs: "Contact Us",
      whyTotarjim: "Why Totarjim",
    },
  },

  // General validation messages

  validation: {
    404: "Sorry this page is not available",
    nameRequired: "Name is required",
  },

  // Translate Form

  translateForm: {
    labels: {
      language: "English",
      name: "Name",
      usefulInfo: "Useful Info !",
      email: "Email",
      translateForm: "Translate From",
      translateTo: "Translate To",
      serviceType: "Service Type",
    },
    buttons: {
      submit: "Submit",
    },
    validation: {
      nameRequired: "Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Email is invalid",
      languageRequired: "Language is required",
      fileRequired: "File is required",
      serviceTypeRequired: "Service Type is required",
    },
    selectOptions: {
      languages: {
        arabic: "Arabic",
        english: "English",
        french: "French",
        spanish: "Spanish",
        german: "German",
        italian: "Italian",
        portuguese: "Portuguese",
        russian: "Russian",
        chinese: "Chinese",
        japanese: "Japanese",
        korean: "Korean",
        vietnamese: "Vietnamese",
        thai: "Thai",
        indonesian: "Indonesian",
        bengali: "Bengali",
        malay: "Malay",
        tagalog: "Tagalog",
        telugu: "Telugu",
        tamil: "Tamil",
        urdu: "Urdu",
        marathi: "Marathi",
        bhojpuri: "Bhojpuri",
        punjabi: "Punjabi",
        gujarati: "Gujarati",
        kannada: "Kannada",
        malayalam: "Malayalam",
        oriya: "Oriya",
        panjabi: "Panjabi",
      },
      services: {
        0: "Graduation research",
        1: "Research paper",
        2: "Legal translation",
        3: "Scientific research",
        4: "Content writer",
        5: "Voice over",
        6: "Blogger",
      },
    },
    placeholders: {
      name: "Enter Name",
      email: "Enter Email",
      serviceType: "Service Type",
      translateForm: "Translate From",
      translateTo: "Translate To",
    },
  },

  sections: {
    header: {
      title: "Your trustworthy translation partner",
      subtitle: "Translate your text from one language to another",
      text: "We are a team of experienced translators and designers. We are here to help you translate your text from one language to another.",
      button: "Services",
      form: {
        success: "Your message has been sent successfully",
        error: "Something went wrong",
        loading: "Sending Email..",
      },
    },
    aboutUs: {
      title: "About Totarjim",
      text: `We take advantage of our advanced technologies to enable our staff to deliver content that fits your business needs quickly and effectively. Translating a business model based on fundamentally changing the way the language services sector operates by integrating artificial intelligence techniques into all steps of our work.`,
      link: "Read More",
    },
    services: {
      title: "Services",
      text: `
      Quis egestas felis eu fermentum adarcu suscipit quis ut gravida dolor amet justo In purus integer dui enim vitae vitae congue volutpat tincidunt sed ac non tempor massa.
      `,
      link: "See More",
      servicesDetails: {
        consulting: {
          title: "Consulting services",
          text: `Our team includes strategic experts from different sectors and fields, who are ready to advise clients on making impact and creating opportunities for untapped potential and efficiencies.`,
        },
        employment: {
          title: "Recruitment and capacity building",
          text: `
          We employ our more than a decade of experience in this field to support our clients through professional staff in order to provide the maximum possible value and reduce the outsourcing as much as possible to accomplish the required tasks.
          `,
        },
        training: {
          title: "Training and professional development",
          text: `
          We use the latest and most advanced tools and methods to collect, organize and analyze data in order to provide our clients with benchmarking and predictive services of the highest level of accuracy.
          `,
        },
        vision: {
          title: "Providing advanced insights",
          text: `
          We use the latest and most advanced tools and methods to collect, organize and analyze data in order to provide our clients with benchmarking and predictive services of the highest level of accuracy.
          `,
        },
      },
    },
    ourTeam: {
      title: "Our Team",
      text: `
      Teamwork is the ability to work together toward a common vision. The ability to direct individual accomplishments toward organizational objectives. It is the fuel that allows common people to attain uncommon results.
      `,
      members: {
        0: {
          name: "Ahmed Siam",
          position: "CO-Founder",
        },
        1: {
          name: "Mohamed Zaina",
          position: "CO-Founder",
        },
        2: {
          name: "Mais Alhasani",
          position: "Translator",
        },
        3: {
          name: "Sarah Turman",
          position: "Translator",
        },
      },
    },
    ourPartners: {
      title: "Our Partners",
      text: `
      Pleasure to work with
      `,
    },
    footer: {
      address: "Palestine, Gaza Strip, Gaza City",
      phone: "+970-567-306-009",
      contactTitle: "Contact Us",
      contactText: `
      A company specialized in providing translation services.
Translating documents with different topics from Arabic to English and vice versa.
Audio and visual transcription.`,
      pages: {
        title: "Pages",
        home: "Home",
        about: "About Us",
        services: "Services",
        ourTeam: "Our Team",
        ourPartners: "Our Partners",
      },
      services: {
        title: "Services",
        0: "Graduation research",
        1: "Research paper",
        2: "Legal translation",
        3: "Scientific research",
        4: "Content writer",
        5: "Voice over",
        6: "Blogger",
      },
    },
  },
  pages: {
    auth: {
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      rememberMe: "Remember Me",
      forgotPassword: "Forgot Password",
      loginWithFacebook: "Login with Facebook",
      loginWithGoogle: "Login with Google",
      loginWithTwitter: "Login with Twitter",
      registerToNameText: "Register to Totarjim",
      loginToNameText: "Login to Totarjim",
      dontHaveAccount: "Don't have an account?",
      createNewAccount: "Create new account",
      haveAccount: "Already have an account?",
      loginNow: "Login now",
      welcomeBack: "Welcome back",
      client: "Client",
      translator: "Translator",
      registerNow: "Register now",
      alreadyHaveAccount: "Already have an account?",
      fullName: "Full Name",
      phoneNumber: "Phone Number",
      emailOrPhoneNumber: "Email / Phone Number",
      requestPasswordChange: "Request Password Change",
      needHelp: "Do you need help?",
      customerSupport: "Customer Support",
      country: "Country",
      useCases: {
        title: "Choose Use Cases",
        note: "Note: Only two can be selected",
        cases: {
          0: "Legal translation",
          1: "Technical translation",
          2: "Financial translation",
          3: "Marketing translation",
          4: "Website Translation",
          5: "Document translation",
        },
      },
    },
  },
};
